import { inject, Injectable } from '@angular/core';
import { CrazyEggService } from '@core/services/crazyegg.service';
import { EnvironmentService } from '@core/services/environment.service';
import { FacebookService } from '@core/services/facebook.service';
import { GtagService } from '@core/services/gtag.service';
import { PlausibleService } from '@core/services/plausible.service';
import { TapfiliateService } from '@core/services/tapfiliate.service';
import { AnalyticsEventName } from '@core/utils/AnalyticsEvents';

export interface Tracker {
    setup(): void;
    trackEvent(
        name: AnalyticsEventName,
        props?: { [key: string]: string | number | boolean }
    ): void;
}

@Injectable({
    providedIn: 'root',
})
export class EventTrackerService implements Tracker {
    private plausibleService = inject(PlausibleService);
    private gtagService = inject(GtagService);
    private facebookService = inject(FacebookService);
    private crazyEggService = inject(CrazyEggService);
    private tapfiliateService = inject(TapfiliateService);
    private environmentService = inject(EnvironmentService);

    setup() {
        if (this.environmentService.isBrowser()) {
            if (this.environmentService.isPreview()) {
                this.plausibleService.disable();
            }
            //These will always set up if not previously disabled
            this.plausibleService.setup();
            this.tapfiliateService.setup();

            //These will only set up, once consent has been given
            this.gtagService.setup();
            this.facebookService.setup();
            this.crazyEggService.setup();
        }
    }

    /*
      This method tracks an event across all services.
      customerId is optional and only used for Tapfiliate.
     */
    trackEvent(
        name: AnalyticsEventName,
        props?: { [key: string]: string | number | boolean },
        customerId?: string
    ) {
        if (this.environmentService.isBrowser()) {
            this.plausibleService.trackEvent(name, props);
            this.gtagService.trackEvent(name, props);
            this.crazyEggService.trackEvent(name, props);
            this.tapfiliateService.trackEvent(name, { customerId: customerId });
        }
    }
}
